export function getGeoJSONFromGeofences(geofences) {
	const geoJson = {
		features: geofences.map((geofence) => ({
			id: geofence.id,
			type: 'Feature',
			geometry: {
				coordinates: [geofence.coordinates],
				type: 'Polygon'
			},
			properties: {
				alertMode: geofence.geofence_type,
				geometryId: geofence.id
			}
		})),
		type: 'FeatureCollection'
	};

	return geoJson;
}
